var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _c(
        "Breadcrumbs",
        {
          staticClass: "breadcrumbs",
          attrs: { "root-icon": "icon-category-organization" },
        },
        [
          _c("Breadcrumb", {
            attrs: {
              title: _vm.t("cookbook", "Home"),
              to: "/",
              "disable-drop": true,
            },
          }),
          _vm._v(" "),
          _vm.isIndex
            ? _c("Breadcrumb", {
                staticClass: "active no-arrow",
                attrs: {
                  title: _vm.t("cookbook", "All recipes"),
                  "disable-drop": true,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isIndex
            ? _c(
                "Breadcrumb",
                {
                  staticClass: "no-arrow",
                  attrs: { title: "", "disable-drop": true },
                },
                [
                  _c(
                    "ActionInput",
                    {
                      attrs: { icon: "icon-quota", value: _vm.filterValue },
                      on: { "update:value": _vm.updateFilters },
                    },
                    [_vm._v(_vm._s(_vm.t("cookbook", "Filter")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "ActionInput",
                    {
                      attrs: { icon: "icon-search" },
                      on: { submit: _vm.search },
                    },
                    [_vm._v(_vm._s(_vm.t("cookbook", "Search")))]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isSearch
            ? _c("Breadcrumb", {
                staticClass: "not-link",
                attrs: { title: _vm.searchTitle, "disable-drop": true },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isSearch && _vm.$route.params.value
            ? _c("Breadcrumb", {
                staticClass: "active",
                attrs: {
                  title:
                    _vm.$route.params.value === "_"
                      ? "None"
                      : decodeURIComponent(_vm.$route.params.value),
                  "disable-drop": true,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isEdit
            ? _c("Breadcrumb", {
                staticClass: "not-link",
                attrs: {
                  title: _vm.t("cookbook", "Edit recipe"),
                  "disable-drop": true,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isEdit
            ? _c(
                "Breadcrumb",
                {
                  staticClass: "active",
                  attrs: {
                    title: _vm.$store.state.recipe.name,
                    "disable-drop": true,
                  },
                },
                [
                  _c(
                    "ActionButton",
                    {
                      staticClass: "action-button",
                      attrs: {
                        icon:
                          _vm.$store.state.reloadingRecipe ===
                          parseInt(_vm.$route.params.id)
                            ? "icon-loading-small"
                            : "icon-history",
                        "aria-label": _vm.t("cookbook", "Reload recipe"),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.reloadRecipeEdit()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.t("cookbook", "Reload recipe")))]
                  ),
                ],
                1
              )
            : _vm.isCreate
            ? _c("Breadcrumb", {
                staticClass: "active",
                attrs: {
                  title: _vm.t("cookbook", "New recipe"),
                  "disable-drop": true,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isEdit || _vm.isCreate
            ? _c(
                "Breadcrumb",
                {
                  staticClass: "no-arrow",
                  attrs: { title: "", "disable-drop": true },
                },
                [
                  _c(
                    "ActionButton",
                    {
                      staticClass: "action-button",
                      attrs: {
                        icon: _vm.$store.state.savingRecipe
                          ? "icon-loading-small"
                          : "icon-checkmark",
                        "aria-label": _vm.t("cookbook", "Save changes"),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.saveChanges()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.t("cookbook", "Save changes")))]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isRecipe
            ? _c(
                "Breadcrumb",
                {
                  staticClass: "active",
                  attrs: {
                    title: _vm.$store.state.recipe.name,
                    "disable-drop": true,
                  },
                },
                [
                  _c(
                    "ActionButton",
                    {
                      staticClass: "action-button",
                      attrs: {
                        icon:
                          _vm.$store.state.reloadingRecipe ===
                          parseInt(_vm.$route.params.id)
                            ? "icon-loading-small"
                            : "icon-history",
                        "aria-label": _vm.t("cookbook", "Reload recipe"),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.reloadRecipeView()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.t("cookbook", "Reload recipe")))]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isRecipe
            ? _c(
                "Breadcrumb",
                {
                  staticClass: "no-arrow",
                  attrs: { title: "", "disable-drop": true },
                },
                [
                  _c(
                    "ActionButton",
                    {
                      staticClass: "action-button",
                      attrs: {
                        icon: "icon-rename",
                        "aria-label": _vm.t("cookbook", "Edit recipe"),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$window.goTo(
                            "/recipe/" + _vm.$store.state.recipe.id + "/edit"
                          )
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.t("cookbook", "Edit recipe")))]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isRecipe
            ? _c(
                "Breadcrumb",
                {
                  staticClass: "no-arrow",
                  attrs: { title: "", "disable-drop": true },
                },
                [
                  _c(
                    "ActionButton",
                    {
                      staticClass: "action-button",
                      attrs: {
                        icon: "icon-category-office",
                        "aria-label": _vm.t("cookbook", "Print recipe"),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.printRecipe()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.t("cookbook", "Print recipe")))]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isRecipe
            ? _c(
                "Breadcrumb",
                {
                  staticClass: "no-arrow",
                  attrs: { title: "", "disable-drop": true },
                },
                [
                  _c(
                    "ActionButton",
                    {
                      staticClass: "action-button",
                      attrs: {
                        icon: "icon-delete",
                        "aria-label": _vm.t("cookbook", "Delete recipe"),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.deleteRecipe()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.t("cookbook", "Delete recipe")))]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isLoading
            ? _c(
                "Breadcrumb",
                {
                  staticClass: "active no-arrow",
                  attrs: {
                    title: _vm.t("cookbook", "App is loading"),
                    "disable-drop": true,
                  },
                },
                [
                  _c("ActionButton", {
                    attrs: {
                      icon: "icon-loading-small",
                      "aria-label": _vm.t("cookbook", "Loading…"),
                    },
                  }),
                ],
                1
              )
            : _vm.isLoadingRecipe
            ? _c(
                "Breadcrumb",
                {
                  staticClass: "active no-arrow",
                  attrs: {
                    title: _vm.t("cookbook", "Loading recipe"),
                    "disable-drop": true,
                  },
                },
                [
                  _c("ActionButton", {
                    attrs: {
                      icon: "icon-loading-small",
                      "aria-label": _vm.t("cookbook", "Loading…"),
                    },
                  }),
                ],
                1
              )
            : _vm.recipeNotFound
            ? _c("Breadcrumb", {
                staticClass: "active no-arrow",
                attrs: {
                  title: _vm.t("cookbook", "Recipe not found"),
                  "disable-drop": true,
                },
              })
            : _vm.pageNotFound
            ? _c("Breadcrumb", {
                staticClass: "active no-arrow",
                attrs: {
                  title: _vm.t("cookbook", "Page not found"),
                  "disable-drop": true,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }